import styled from 'styled-components';
import {  Grid } from '@met/react-components';

const StyledGrid = styled(Grid)`
  width: auto;
`;

export { StyledGrid };